/** @format */

import React, { FC, useEffect, useState } from 'react'
import { _$, Button, Card, Dialog, Message, Tip } from '@king-design/react'
import { useHistory } from 'react-router'
import { useAsyncFn } from 'react-use'
import styled from 'styled-components'
import { MonitorCrumb, TablePage } from 'src/components'
import useFormTable from 'src/hooks/useFormTable'
import API, { createGrafanaInstance } from 'src/api/ApiGrafana'
import { getPromethuesInstance } from 'src/api/ApiPromethuesInstance'
let timer: NodeJS.Timeout = null

const InstanceList: FC<any> = ({ className }) => {
  const history = useHistory()
  const [refresh, setRefresh] = useState<boolean>(false)

  // 账户下是否有实例
  const [, have_fetch] = useAsyncFn(async () => {
    const result = await getPromethuesInstance()
    if (!!result?.InstancesSet?.length) {
      createInstance()
    } else {
      noPrometheusDialog()
    }
    return !!result?.InstancesSet?.length
  }, [])

  // 开通Grafana实例
  // eslint-disable-next-line no-empty-pattern
  const [{}, create_fetch] = useAsyncFn(async () => {
    const result = await createGrafanaInstance()
    if (result?.InstancesSet) {
      Message.info(_$('开通成功'))
      run()
    }
    return result
  }, [])

  // 未检测到有Prometheus实例提示
  const noPrometheusDialog = async () => {
    Dialog.confirm({
      title: _$('未检测到有Prometheus实例'),
      okText: _$('去开通Prometheus'),
      content: _$('当前所有Region下均未发现Prometheus实例，请先开通Prometheus实例。')
    }).then(
      async () => {
        history.push('/monitor/prometheusmonitor/instanceinfo')
      },
      () => {
        // 取消
      }
    )
  }

  // 开通实例二次确认
  const createInstance = async () => {
    Dialog.confirm({
      title: _$('确认开通'),
      okText: _$('开通'),
      content: _$('将为您开通Grafana实例。是否开通')
    }).then(
      async () => {
        await create_fetch()
      },
      () => {
        // 取消
      }
    )
  }
  // useFormTable
  const { run, result, pageState, loading, total } = useFormTable(
    API.getGrafanaList,
    {
      params: {}
    },
    data => {
      // 判断实例中是否存在开通中的实例
      const openRefresh = data?.InstancesSet?.some(item => item.InstanceStatus === 'launching')
      setRefresh(openRefresh)
      return {
        // 过滤掉已删除的实例
        tableData: data?.InstancesSet.filter(item => item.InstanceStatus !== 'deleted') || [],
        totalCount: data?.totalCount
      }
    }
  )

  // 开启定时刷新
  useEffect(() => {
    if (refresh) {
      timer = setInterval(() => {
        run()
      }, 10000)
    } else {
      clearInterval(timer)
      timer = null
    }
    return () => {
      clearInterval(timer)
    }
  }, [refresh])

  const scheme = {
    InstanceName: {
      title: _$('实例名称')
    },
    InstanceStatusDesc: {
      title: _$('运行状态')
    },
    CreatedAt: {
      title: _$('创建时间'),
      template({ InstanceStatus, CreatedAt }) {
        return <span>{InstanceStatus === 'running' ? CreatedAt : '-'}</span>
      }
    },
    GrafanaVersion: {
      title: _$('版本号'),
      template() {
        return <span>Grafana v11.6.0</span>
      }
    },
    action: {
      title: _$('操作'),
      template({ InstanceID, AccessURL, AccessToken, InstanceStatus }) {
        const url = `${AccessURL}/dashboards?auth_token=${AccessToken}`
        return InstanceStatus === 'running' ? (
          <div className="ksc-space">
            <a
              onClick={() => {
                history.push(`/monitor/grafana/instancelist/view/${InstanceID}`)
              }}
            >
              {_$('查看')}
            </a>
            <a
              onClick={() => {
                window.open(url)
              }}
            >
              {_$('公网地址')}
            </a>
          </div>
        ) : (
          '-'
        )
      }
    }
  }
  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('Grafana服务') }, { title: _$('实例信息') }]} />
      <Card>
        {!loading ? (
          result?.length ? (
            <div className="instance_list">
              {result?.[0]?.InstanceStatus === 'launch_failed' ? (
                <Tip type="danger">{_$('开通失败，请创建工单或联系售后人员')}</Tip>
              ) : null}
              <TablePage
                style={{ marginTop: 0 }}
                tableProps={{
                  data: result || [],
                  scheme: scheme,
                  checkType: 'none',
                  rowKey: value => value.clusterId,
                  rowCheckable: false
                }}
                pageProps={{ total, ...pageState }}
                loading={loading}
                run={run}
              />
            </div>
          ) : (
            <div className="activate_box">
              <h3>{_$('开通金山云共享版Grafana')}</h3>
              <p>
                {_$(
                  '金山云共享版Grafana实例为您提供多租户共享的监控仪表盘，支持基础数据可视化功能。'
                )}
              </p>
              <Button
                type="primary"
                onClick={() => {
                  have_fetch()
                }}
              >
                {_$('开通实例')}
              </Button>
            </div>
          )
        ) : null}
      </Card>
    </div>
  )
}

export default styled(InstanceList)`
  padding: 0 16px;
  .instance_list {
    .add_button {
      margin-bottom: 16px;
    }
  }
  .activate_box {
    h3 {
      font-size: 18px;
    }
    p {
      margin: 16px 0;
      font-size: 14px;
    }
  }
  .k-danger {
    margin-bottom: 8px;
  }
`
